
export const Classes = {
    Text: "text-neutral-600 dark:text-neutral-100",
    GradientText: "text-transparent bg-clip-text bg-gradient-to-r from-neutral-600 to-neutral-600/50 dark:from-neutral-100 dark:to-neutral-100/50",
    Background0: "fixed h-[50vh] w-[50vw] bg-gradient-to-r from-orange-500/60 via-sky-500/10 to-sky-500/30 blur-[200px] opacity-25 rounded-[20%] -top-32 left-1/2 -translate-x-1/2 pointer-events-none",
}